/**
 * Go Green LED — Product Gallery
 * Thumbnail switching, image counter, lifestyle/product toggle,
 * and sticky add-to-cart bar on the product detail page.
 */

document.addEventListener('DOMContentLoaded', () => {
  /* ------------------------------------------------------------------ */
  /*  Element references                                                 */
  /* ------------------------------------------------------------------ */

  const thumbnails   = document.querySelectorAll('.pdp__thumbnail');
  const mainImage    = document.querySelector('.pdp__main-image img');
  const mainImageWrap = document.querySelector('.pdp__main-image');
  const imageCounter = document.querySelector('.pdp__image-counter');
  const stickyBar    = document.querySelector('.sticky-bar');

  /* ------------------------------------------------------------------ */
  /*  Thumbnail click — swap main image                                  */
  /* ------------------------------------------------------------------ */

  if (thumbnails.length && mainImage) {
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        // Remove active state from all thumbnails
        thumbnails.forEach((t) => t.classList.remove('pdp__thumbnail--active'));

        // Mark clicked thumbnail as active
        thumb.classList.add('pdp__thumbnail--active');

        // Update main image source from thumbnail data
        const newSrc = thumb.getAttribute('data-src') ||
                       thumb.querySelector('img')?.src;
        if (newSrc) {
          mainImage.src = newSrc;
        }

        // Update image counter text (e.g. "2 / 5")
        if (imageCounter) {
          imageCounter.textContent = `${index + 1} / ${thumbnails.length}`;
        }

        // Toggle lifestyle vs product image class.
        // Thumbnails can carry a data-type="lifestyle" attribute;
        // all others are treated as standard product images.
        if (mainImageWrap) {
          const isLifestyle = thumb.getAttribute('data-type') === 'lifestyle';
          mainImageWrap.classList.toggle(
            'pdp__main-image--lifestyle',
            isLifestyle
          );
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Sticky add-to-cart bar                                             */
  /* ------------------------------------------------------------------ */

  const STICKY_THRESHOLD = 600;

  function handleStickyBar() {
    if (!stickyBar) return;

    const show = window.scrollY > STICKY_THRESHOLD;
    stickyBar.classList.toggle('sticky-bar--visible', show);
  }

  if (stickyBar) {
    window.addEventListener('scroll', handleStickyBar, { passive: true });

    // Check on load in case the page is already scrolled
    handleStickyBar();
  }
});
